// Translation: Account > Profile > Networks (Ukrainian)
export default Object.freeze({
	form: {
		fields: {
			profileGitHub: {
				label: '',
				placeholder:''
			},
			profileGoogleScholar: {
				label: '',
				placeholder:''
			},
			profileLinkedIn: {
				label: '',
				placeholder:''
			}
		}
	},
	title: ''
})
